<template>
  <div class="wrapper">
    <div class="switch" @click="onOpen">
      <div class="image">
        <img src="../../../images/person_list/screen_icon.png" />
      </div>
      <span>近{{ value }}天</span>
    </div>
    <div v-if="isOpen" class="values">
      <div
        v-for="(item, index) in values"
        :key="index"
        :class="[value === item.value && 'active']"
        @click="onClick(item.value)"
      >
        {{ item.title }}
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    values: {
      type: Array,
      default: () => []
    },
    onItemClick: {
      type: Function,
      default: null
    }
  },
  data() {
    return {
      value: 7,
      isOpen: false
    }
  },
  methods: {
    onOpen() {
      this.isOpen = !this.isOpen
    },
    onClick(item) {
      this.value = item
      this.isOpen = !this.isOpen
      this?.onItemClick(item)
    }
  }
}
</script>
<style scoped lang="scss">
.wrapper {
  position: relative;
}

.switch {
  .image {
    display: inline-block;

    width: 0.22rem;
    height: 0.22rem;

    margin-right: 0.12rem;
    img {
      display: block;

      width: 100%;
      height: 100%;
    }
  }
  span {
    font-size: 0.28rem;
    color: #666;
  }
}
.values {
  position: absolute;
  top: 0.48rem;
  left: 0;

  width: 2.28rem;

  padding-left: 0.36rem;

  background-color: #fff;
  border-radius: 0.16rem;

  font-size: 0.3rem;
  color: #222;

  box-shadow: 0px 2px 10px 0px rgba(186, 186, 186, 0.5);

  > * {
    margin: 0.4rem 0;
  }
  .active {
    color: #15bb5c;
  }
  &::after {
    display: inline-block;

    position: absolute;
    top: -0.1rem;
    left: 0.6rem;

    transform: rotate(-45deg);

    width: 0;
    height: 0;

    margin: auto;

    border-width: 0.12rem;
    border-style: solid;
    border-color: #fff #fff transparent transparent;

    content: '';
  }
}
</style>
